import { useParams } from 'react-router';
import { useGetClinicalDataList } from '#api/clinical-data';
import { ClinicalDataItem } from '#organisims';
import { Container } from './styles';

export function CoachClinicalDataPage() {
  const { id } = useParams();

  const { data: clinicalDataList } = useGetClinicalDataList({
    coachId: id ?? '',
    offset: 100
  });

  return (
    <Container>
      {clinicalDataList &&
        clinicalDataList.data.map((data, idx) => (
          <ClinicalDataItem data={data} key={idx} />
        ))}
    </Container>
  );
}
